import EventMarker from "../EventMarker";
import {statuses} from "../../../Config";
import React from "react";
import {Grid} from "@material-ui/core";
import {DateFormat} from "../../../../../helpers/DateFormat";
import {DirectionsCar, Notifications} from "@material-ui/icons";
import purge from "../Purge"
import Rest from "../../../../../helpers/Rest";

const EVENT_TYPE = 0, DISTANCE = 1, UWB_DISTANCE = 2, MINIMUM_SOUNDER_DISTANCE = 3,
    MINIMUM_UWB_DISTANCE = 4, EVENT_DURATION = 5, LATITUDE = 6, LONGITUDE = 7, SPEED = 8, COURSE = 9,
    ACCURACY = 10, COL_CODE = 11, COL_NAME = 12, COL_LATITUDE = 13, COL_LONGITUDE = 14, COL_SPEED = 15, COL_COURSE = 16,
    COL_ACCURACY = 17, DRIVER_CODE = 18, DRIVER_NAME = 19, DRIVER_2_CODE = 20, DRIVER_2_NAME = 21, TIMESTAMP = 22

function getColour(eventType){
    return eventType === "warning" ? statuses.warning.colour : statuses.faulty.colour
}

function getMarkerSvg(angle, colour){
    return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
            <g transform="rotate(${angle - 180} 17.5 17.5)">
                <g transform="translate(-4.000000, -4.000000)">
                    <path d="M21.5,7.5 C29.2175,7.5 35.5,13.7825 35.5,21.5 C35.5,29.2175 29.2175,35.5 21.5,35.5 C13.7825,35.5 7.5,29.2175 7.5,21.5 C7.5,13.7825 13.7825,7.5 21.5,7.5 M21.5,4 C11.84,4 4,11.84 4,21.5 C4,31.16 11.84,39 21.5,39 C31.16,39 39,31.16 39,21.5 C39,11.84 31.16,4 21.5,4 L21.5,4 Z M23.25,21.5 L23.25,14.5 L19.75,14.5 L19.75,21.5 L14.5,21.5 L21.5,28.5 L28.5,21.5 L23.25,21.5 Z" fill="${colour}"/>
                </g>
            </g>
        </svg>
    `
}

function property(key, value){
    return (
        <React.Fragment key={key}>
            <Grid item xs={6}>
                <b>{key}</b>
            </Grid>
            <Grid item xs={6}>
                {value}
            </Grid>
        </React.Fragment>
    )
}

function toLabel(eventType){
    return eventType.substring(0, 1).toUpperCase() + eventType.substring(1)
}

function eventType(icon, event, classes){
    const type = event[EVENT_TYPE]
    return (
        <React.Fragment key={type}>
            <Grid item xs={6}>
                <b style={{color: getColour(type)}} className={classes.event}>{icon}{toLabel(type)}</b>
            </Grid>
            <Grid item xs={6}>
                {(new DateFormat(event[TIMESTAMP])).datetime()}
            </Grid>
        </React.Fragment>
    )
}

function properties(icon, victim, event, classes){
    return [
        eventType(icon, event, classes),
        Rest.isAdmin ? property("Distance", purge(event[DISTANCE], 'm')) : null,
        property("Driver", purge(event[DRIVER_NAME])),
        property(victim, purge(event[COL_NAME])),
        property("Speed", purge(event[SPEED], 'kph'))
    ]
}

function getPosition(row) {
    return EventMarker.latLng(row[LATITUDE], row[LONGITUDE])
}

export default {
    type: "event",
    label: "Collisions",
    getPosition: getPosition,
    getMarkers: (row) => {
        const colour = getColour(row[EVENT_TYPE]);
        const me = new EventMarker(
            getPosition(row),
            getMarkerSvg(row[COURSE], colour),
            row[ACCURACY]
        )
        const other = row[COL_COURSE];
        return other ? [
            me, new EventMarker(
                EventMarker.latLng(row[COL_LATITUDE], row[COL_LONGITUDE]),
                getMarkerSvg(other, colour),
                row[COL_ACCURACY]
            )
        ] : [me]
    },
    timestampOffset: TIMESTAMP,
    getProperties: (row, type, classes) => {
        return row[COL_CODE].charAt(0) === 'V' ? properties(
            <DirectionsCar/>, "Vehicle", row, classes
        ) : properties(
            <Notifications/>, "Pedestrian", row, classes
        )
    }
}
